import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MulticauseSelectionComponent } from './multicause-selection.component';
import { SharedModule } from '../../shared/shared.module';
import {MatIconModule} from '@angular/material/icon'


@NgModule({
  declarations: [MulticauseSelectionComponent],
  exports: [MulticauseSelectionComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatIconModule
  ]
})
export class MulticauseSelectionModule { }
